import { GridColDef, GridColumnVisibilityModel, GridPinnedColumns } from '@mui/x-data-grid-pro'

export interface IColumnManagerContext {
  columnsConfig: Array<GridColDef>
  columnVisibilityModel: GridColumnVisibilityModel
  pinnedColumns: GridPinnedColumns
  lockedColumns: Array<string>
  onToggleColumnVisibility(field: string): void
  onColumnVisibilityModelChange(model: GridColumnVisibilityModel): void
  onPinColumn(field: string): void
  onUnpinColumn(field: string): void
}

export const defaultColumnManagerContext: IColumnManagerContext = {
  columnsConfig: [],
  columnVisibilityModel: {},
  pinnedColumns: {},
  lockedColumns: [],
  onToggleColumnVisibility: () => {},
  onColumnVisibilityModelChange: () => {},
  onPinColumn: () => {},
  onUnpinColumn: () => {},
}
